import '../css/menu.css'
import '../css/switch-button.css'

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Me_menu_img from '../img/user.png';
import Work_menu_img from '../img/portfolio.png';
import Hobbies_menu_img from '../img/hobbies.png';
import Projects_menu_img from '../img/project.png';
import Contact_menu_img from '../img/chat.png';

const Me_menu_item = {
    name: "Me",
    path: "/",
    image: Me_menu_img
};
const Work_menu_item = {
    name: "Work",
    path: "/work",
    image: Work_menu_img
};
const Hobbies_menu_item = {
    name: "Hobbies",
    path: "/hobbies",
    image: Hobbies_menu_img
};
const Projects_menu_item = {
    name: "Projects",
    path: "/projects",
    image: Projects_menu_img
};
const Contact_menu_item = {
    name: "Contact",
    path: "/contact",
    image: Contact_menu_img
};



const menues = [Me_menu_item,Work_menu_item,Hobbies_menu_item,Projects_menu_item,Contact_menu_item];

export function Menu(props){
    
    const lang = props.lang;
    const langsetter = props.langsetter;
    const navigate = useNavigate();
    const [isChecked, setIsChecked] = useState(false);
    const [textClass,setTextClass] = useState('switch-label__text');

    const changeHandler = e => {
        setIsChecked(!isChecked);
        if(isChecked){
            langsetter('es');
            setTextClass('switch-label__text');
        }else{
            langsetter('en');
            setTextClass('switch-label__text__active');
        }
    };

    return(
        <div className='menu'>
            {menues.map(menu =>(
                <img key={menu.name} className='menu_img' src={menu.image} alt={menu.name} width="32px;" height="32px;" onClick={() => navigate(menu.path)}/>        
            ))}
             <div className="switch-button" onChange={e => changeHandler(e)} >
                <input type="checkbox" name="switch-button" id="switch-label" className="switch-button__checkbox" checked={isChecked}/>
                <label for="switch-label" className="switch-button__label"><div className={textClass}>{lang}</div></label>
            </div>
        </div>
       
    );
}
